import React from 'react';

import { useSelector } from 'react-redux';
import PrimaryButton from 'shared/buttons/PrimaryButton';
import { ButtonColor, ButtonType } from 'shared/buttons/models/ButtonModels';
import IconButton from 'shared/buttons/IconButton';
import { RootState } from 'redux/store';
import SeparatorWidget from 'shared/widgets/SeparatorWidget';

export default ({
  switchActiveSection,
  activeSection
}: {
  switchActiveSection: (type: string) => void;
  activeSection: string;
}) => {
  const { inspector, isThemeEditor } = useSelector<any, any>((state: RootState) => state.chartEditorPage);

  const toggleInspector = () => {
    inspector.toggleActive(true);
  };

  const isBasic = activeSection === 'basic';
  const isAdvanced = activeSection === 'advanced' || activeSection === 'inspector';

  return (
    <div className="highed-icons-container customize-icons mt-2 hidden ev-sm:block">
      <div className="flex gap-4 w-[332px]">
        <div className="w-3/5 flex gap-2">
          <PrimaryButton
            text="Basic"
            onClick={() => switchActiveSection('basic')}
            buttonColor={isBasic ? ButtonColor.NavyBlue : ButtonColor.White}
            buttonType={ButtonType.Info}
            className={`grow text-sm ${isBasic ? '' : 'font-medium underline'}`}
          />
          <PrimaryButton
            text="Advanced"
            onClick={() => switchActiveSection('advanced')}
            buttonColor={isAdvanced ? ButtonColor.NavyBlue : ButtonColor.White}
            buttonType={ButtonType.Info}
            className={`grow text-sm ${isAdvanced ? '' : 'font-medium underline'}`}
          />
        </div>

        {!isThemeEditor && (
          <div className="flex gap-2 ml-auto">
            <IconButton
              icon={'crosshairs'}
              tooltipText="Inspector"
              onClick={() => {
                toggleInspector();
                switchActiveSection('inspector');
              }}
              buttonColor={activeSection !== 'inspector' ? ButtonColor.White : ButtonColor.NavyBlue}
              className="w-8 h-8 rounded"
            />

            <IconButton
              icon={'code'}
              tooltipText="Custom code"
              onClick={() => switchActiveSection('customcode')}
              buttonColor={activeSection !== 'customcode' ? ButtonColor.White : ButtonColor.NavyBlue}
              className="w-8 h-8 rounded"
            />

            <IconButton
              icon={'eye'}
              tooltipText="Preview"
              onClick={() => switchActiveSection('preview')}
              buttonColor={activeSection !== 'preview' ? ButtonColor.White : ButtonColor.NavyBlue}
              className="w-8 h-8 rounded"
            />
          </div>
        )}
      </div>
      <SeparatorWidget />
    </div>
  );
};
